export default "__VITE_ASSET__DDt8LgTa__"